<template>
    <button
        v-if="!active"
        class="btn btn-sm btn-success"
        type="button"
        @click="openModal()"
    >
        <i class="fa fa-check"></i>
        <span class="sr-only">Active</span>
    </button>
    <button
        v-else
        class="btn btn-sm btn-danger"
        type="button"
        @click="openModal()"
    >
        <i class="fa fa-ban"></i>
        <span class="sr-only">Deactivate</span>
    </button>
</template>

<script>
export default {
    props: {
        'id': Number,
        'type': String,
        'active': Boolean,
        'route': Object,
        'modal': Object,
    },
    methods: {
        click: function () {
            this.$emit('click');
        },
        getRoute: function (id, type) {
            return this.route[type].replace(':id:', id);
        },
        openModal: function () {
            this.click();
            if (!this.active && this.type === 'active') {
                this.modal.header = 'Activate Body #' + this.id
                this.modal.body = 'Confirm the Body activation please.';
                this.modal.action = this.getRoute(this.id, this.type);
                this.modal.id = this.id;
                this.modal.approveText = '';
                this.modal.denyText = '';
                this.modal.method = 'PUT';
            } else {
                this.modal.header = 'Deactivate Body #' + this.id
                this.modal.body = 'Confirm the Body deactivation please.';
                this.modal.action = this.getRoute(this.id, this.type);
                this.modal.id = this.id;
                this.modal.approveText = '';
                this.modal.denyText = '';
                this.modal.method = 'PUT';
            }
        }
    },
}
</script>
